import { FunctionComponent, PropsWithChildren } from 'react';
import { useConfigProfilesNavigationItems, RouteSegments } from '@cbridge-packages/routing-client-admin';
import { ConfigPageLayout } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { DashboardSidebarSubNavigation } from '@cbridge-modules/sidebar';

export const ProfilesLayout: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const profilesNavigation = useConfigProfilesNavigationItems();
  return (
    <ConfigPageLayout settingsKey={UserSettingsPage.ConfigProfiles}>
      <DashboardSidebarSubNavigation
        items={profilesNavigation}
        variant={'secondary'}
        basePath={`/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}`}
        isMini={false}
        isFullyExpanded={true}
      />
      {children}
    </ConfigPageLayout>
  );
};
